export const hideLoading = () => {
    const loading = document.querySelector('.emr-loading');
    const overlay = document.querySelector('.emr-overlay');
    if (loading) {
		loading.remove();
		overlay.remove();
    }
}